export const rasterizeCtaSvgImages = async (source: HTMLElement, target: HTMLElement): Promise<void> => {
    const sourceImages = source.querySelectorAll<HTMLImageElement>('#cta-personal img');
    const targetImages = target.querySelectorAll<HTMLImageElement>('#cta-personal img');

    for (let i = 0; i < sourceImages.length; i++) {
        const image = sourceImages[i];
        const src = image.currentSrc || image.src;
        if (!/\.svg(?:[?#]|$)/i.test(src) && !/^data:image\/svg\+xml[;,]/i.test(src)) {
            continue;
        }

        await image.decode();
        const width = image.clientWidth || image.naturalWidth;
        const height = image.clientHeight || image.naturalHeight;
        if (!width || !height || !image.naturalWidth || !image.naturalHeight) {
            throw new Error(`Cannot rasterize CTA image with empty dimensions: ${src}`);
        }

        const canvas = document.createElement('canvas');
        canvas.width = Math.ceil(width * 2);
        canvas.height = Math.ceil(height * 2);
        const context = canvas.getContext('2d');
        if (!context) {
            throw new Error(`Cannot create canvas context for CTA image: ${src}`);
        }

        // Fit the SVG inside its existing box without stretching its intrinsic aspect ratio.
        const scale = Math.min(canvas.width / image.naturalWidth, canvas.height / image.naturalHeight);
        const drawWidth = image.naturalWidth * scale;
        const drawHeight = image.naturalHeight * scale;
        context.drawImage(image, (canvas.width - drawWidth) / 2, (canvas.height - drawHeight) / 2, drawWidth, drawHeight);

        const exportImage = targetImages[i];
        exportImage.src = canvas.toDataURL('image/png');
        exportImage.removeAttribute('srcset');
        exportImage.removeAttribute('sizes');
        exportImage.style.width = `${width}px`;
        exportImage.style.height = `${height}px`;
    }
};
